import React, { Fragment, useEffect, useState } from 'react'
import { FetchAxiosDelte, FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from '../../../api/axios'
import { GetCookieToken } from '../../Cookie/GetCookie'
import LoadingData from '../../TESTPage/LoadingData'
import FadeIn from 'react-fade-in/lib/FadeIn'
import { Badge, Button, Col, FormFeedback, FormGroup, Input, InputGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Table } from 'reactstrap'
import Select from 'react-select';
import { ConvertDate } from '../../Function/ConvertDate'
import ConfirmModal from '../../../components/Common/ConfirmModal'

const token = GetCookieToken('userToken')

function UserpositionNoDatatable() {
    const [dataTable, setDataTable] = useState([])
    const [dataInfo, setDataInfo] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [confirmModal, setConfirmModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [confirmModalState, setConfirmModalState] = useState("");
    const [inversedSort, setInversedSort] = useState(false);
    const [indexSort, setIndexSort] = useState(2);
    const [modal, setModal] = useState(false);
    const [modalState, setModalState] = useState("");
    const [dataInput, setDataInput] = useState({posi_no_id: null, name_posi_no: null, status: null});
    const [usersOptions, setUsersOptions] = useState([]);
    const [usersOnlyOptions, setUsersOnlyOptions] = useState([]);
    const [dataInputSwap, setDataInputSwap] = useState([]);
    const [checkNumber, setCheckNumber] = useState(false);
    const [conditonMessage, setConditonMessage] = useState(false);
    const [checkSwitchUserPosiNo, setCheckSwitchUserPosiNo] = useState(false)
   
    const positionNoDataTable = async (fillter = null, valueID = null, orderBy = "posi_no_id", sortedBy = "ASC") =>{
        let params = new URLSearchParams({
            page: currentPage,
            size: 10,
            "order[0]": orderBy,
            "order[1]": sortedBy,
        })
        if (fillter !== null && valueID !== null && valueID !== '0') {
            params.append(`filter[${fillter}][0]`, valueID)
        }
        const response = await FetchAxiosGet('/api/positionNo/datatable', token, params)
        setDataTable(response.result)
        setDataInfo(() => response.info);
        setTotalPages(Math.ceil(response.info.totalRows / 10));
    }

    const fetchData = async () => {
        setConditonMessage(true)
        let params;
        params = new URLSearchParams({
            page: currentPage,
            size: 1000,
            "order[0]": "posi_no_id",
            "order[1]": "ASC",
        })
        let options;
        const allPositionNumber = await FetchAxiosGet('/api/positionNo/datatable', token, params)
        if (modalState === "EDIT") {
            options = [];
        } else {
            options = [{ value: '0', label: 'กรุณาเลือก' }];
        }

        options.push(allPositionNumber?.result?.map(obj => ({value: obj.posi_no_id, label: `เลขที่ตำแหน่งที่ ${obj.posi_no_id}`, feild: "posi_no_id"})))
        options.flat()
        options = options.flat()

        params = new URLSearchParams({
            page: 1,
            size: 1000,
            "order[0]": "user_name",
            "order[1]": "ASC",
            "filter[deleted][0]": "1",
            "filter[user_name_status][0]": "ปกติ",
            "filter[user_outsider][0]": 0,
            "filter[user_special][0]": 0,
        });
        const response = await FetchAxiosGet('/api/users/datatable', token, params)
            response.result.map(x => options.push({ value: x.user_id, label: x.user_name, feild: "user_id" }));
            setUsersOptions(options);
            setUsersOnlyOptions(options);
            setConditonMessage(false)
    };

    const positionNoEditDataTable = async (id) =>{
        const editData = dataTable.find(x => x.position_no_id === id)
        setDataInput({
            posi_no_id: editData.posi_no_id,
            name_posi_no: editData.name_posi_no,
            position_no_id: id,
            user_id: editData.user_id,
            status: editData.status,
        })
    }

    const positionNoDeleteDataTable = async () =>{
        const response = await FetchAxiosDelte(`/api/positionNo/${dataInput?.position_no_id}`, token)
        toggles('delte')
        setLoading(true)
        positionNoDataTable()
        fetchData()
        setTimeout(() => { setLoading(false) }, 1000);
    }

    const checkValidateNumber = async (event) =>{
        let params = new URLSearchParams({
          page: 1,
          size: 1,
          "order[0]": "user_id",
          "order[1]": "DESC",
          "filter[posi_no_id][0]": event,
        })
        const res = await FetchAxiosGet("/api/positionNo/datatable",token,params)
        if (res.result.length === 0) {
          return true
        } else {
          return false
        }
    }

    const headerTable = [
        { field: "posi_no_id", label: "เลขที่ตำแหน่ง" },
        { field: "name_posi_no", label: "ตำแหน่ง" },
        { field: "status", label: "สถานะผู้ใช้งาน" },
        { field: "user_id", label: "ผู้ครองตำแหน่ง" },
        { field: "date_start", label: "วันที่เริ่ม" },
    ]

    const handleHeaderClick = (value, index, inversed) => {
        setIndexSort(index)
        setInversedSort(inversed)
        positionNoDataTable(null, null, value, inversed ? "DESC" : "ASC")
    }
    
    const sortIcon = (index) => {
        return (
          <i className={`ps-2 ${indexSort === index ? `fa-duotone fa-sort-${inversedSort ? "down" : "up"}` : "text-secondary fa-regular fa-sort"}`}/>
        );
    }

    const hoverEffect = (e, inOut) => {
        e.target.style.backgroundColor = inOut ? "rgba(215,218,222,0.6)" : "rgba(239,242,247,1)"
    }

    const handleInputChange = async (event, field, number = false, checkbox = false, rawData = false) => {
        let value
        if (event == 1) {
            value = 1
        } else {
            if (rawData) {
                value = event
            } else {
                value = checkbox ? event : event.target.value; 
            }
        }
        
        setDataInput(prevData => ({ ...prevData, [field]: number ? Number(value) : value }));
    };

    const toggles = (delte = null) =>{
        if (delte !== null) {
            setModal(false)
        } else {
            setModal(!modal)
        }
        setModalState("")
        setDataInput({
            posi_no_id: null,
            name_posi_no: null
        })
        setCheckSwitchUserPosiNo(false)
    }

    const fetchToDB = async () => {
        if (modalState === "ADD") {
            const intoDB = await FetchAxiosPost('/api/positionNo/save', dataInput, token)
        } else if (modalState === "EDIT") {
            if (usersOptions.find(option => option.value == dataInput?.user_id)?.value) {
                const swap_data = InputSwap(dataInputSwap)
                if (swap_data.length > 0) {
                    swap_data.map(async item => {
                        const intoDB = await FetchAxiosPut(`/api/positionNo/${item?.position_no_id}`, 
                            {
                                user_id: item?.user_id,
                                posi_no_id: item?.posi_no_id,
                                name_posi_no: item?.name_posi_no
                            }, token)
                        const url = `/api/users/${item?.user_id}`;
                        const arr_for_edit =["user_title_id", "user_title_name", "user_name", "user_login"]
                        let filteredData = {};
                        let params = new URLSearchParams({
                            page: 1,
                            size: 1000,
                            "order[0]": "user_name",
                            "order[1]": "ASC",
                            "filter[user_id][0]": item?.user_id,
                        });
                        const response_now = await FetchAxiosGet('/api/users/datatable', token, params)
                        for (const key in response_now?.result[0]) {
                            if (arr_for_edit.includes(key)) {
                                filteredData[key] = response_now?.result[0][key];
                            }
                        }
                        const app_config = await FetchAxiosGet("/api/users/config/all", token)
                        filteredData.user_no_position = item?.posi_no_id;
                        filteredData.user_position_name = item?.name_posi_no;
                        filteredData.user_title_id = app_config?.result?.user_title?.find(x => x.name == filteredData.user_title_name)?.id;
                        FetchAxiosPut(url, filteredData, token);
                    })  
                } else {
                    let data = {
                        posi_no_id: dataInput.posi_no_id, 
                        name_posi_no: dataInput.name_posi_no, 
                        status: dataInput.status,
                        user_id: dataInput.user_id || null
                    }
                    // console.log(dataInput.user_id, ": 214")
                    const intoDB = await FetchAxiosPut(`/api/positionNo/${dataInput?.position_no_id}`, data, token)
                }
            } else {
                let data = {
                    posi_no_id: dataInput.posi_no_id, 
                    name_posi_no: dataInput.name_posi_no, 
                    status: dataInput.status,
                    user_id: dataInput.user_id || null
                }
                // console.log(dataInput.user_id, ": 223")
                const intoDB = await FetchAxiosPut(`/api/positionNo/${dataInput?.position_no_id}`, data, token)
            }
        }
        toggles()
        setLoading(true)
        positionNoDataTable()
        fetchData()
        setTimeout(() => { setLoading(false) }, 1000);
    }

    const positionNoSwapData = async (fillter = null, valueID = null, orderBy = "posi_no_id", sortedBy = "ASC") =>{
        let params = new URLSearchParams({
            page: currentPage,
            size: 10,
            "order[0]": orderBy,
            "order[1]": sortedBy,
        })
        if (fillter !== null && valueID !== null && valueID !== '0') {
            params.append(`filter[${fillter}][0]`, valueID)
        }
        const response = await FetchAxiosGet('/api/positionNo/datatable', token, params)
        setDataInputSwap([ dataInput, {
            posi_no_id: response?.result[0]?.posi_no_id,
            name_posi_no: response?.result[0]?.name_posi_no,
            position_no_id: response?.result[0]?.position_no_id,
            user_id: response?.result[0]?.user_id,
            status: response?.result[0]?.status
        }])
    }

    const InputSwap = ((prevData) => {
        if (prevData.length < 2) return prevData;
        const swappedData = [...prevData];
        const tempUserId = swappedData[0].user_id;
        swappedData[0].user_id = swappedData[1].user_id;
        swappedData[1].user_id = tempUserId;
        return swappedData;
    });
    
    useEffect(() => {
        setLoading(true)
        positionNoDataTable()
        fetchData()
        setTimeout(() => { setLoading(false) }, 1000);
    }, [currentPage])

    useEffect(() => {
        const filteredArray = usersOptions.filter(item => item.value !== "0");
        if (modalState === "EDIT") {
            setUsersOptions(filteredArray)
        } else {
            const removedItem = { value: "0", label: "กรุณาเลือก" };
            filteredArray.splice(0, 0, removedItem);
            setUsersOptions(filteredArray)
        }
    }, [modalState])
    
    return (
        <Fragment>
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                    <LoadingData />
                </div>
            ) : (
                <FadeIn>
                <Row className="mb-3">
                    <Col xs={12} md={10} lg={6} className="mt-2">
                        <Select className="basic-single" classNamePrefix="เลขที่ตำแหน่งหรือเจ้าหน้าที่" isSearchable={true} placeholder='เลขที่ตำแหน่งหรือเจ้าหน้าที่...' options={usersOptions} required={true}
                            noOptionsMessage={()=>conditonMessage ? "กำลังดาวน์โหลดข้อมูล..." : "ไม่พบรายชื่อเจ้าหน้าที่ดังกล่าว"}
                            // loadingMessage={()=>"กำลังดาวน์โหลดข้อมูล"}
                            defaultValue='0'
                            onChange={e => { positionNoDataTable(e?.feild, e?.value) }} 
                        />
                    </Col>
                    <Col xs={12} md={2} lg={6} style={{ display: "flex", justifyContent: "end" }} className="mt-2">
                        <Button color="primary" onClick={() => {setModal(true); setModalState("ADD")} }><i className="fa-solid fa-user-plus me-1"></i> เพิ่มข้อมูล </Button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <Table className="align-middle" striped style={{ overflow: "scroll", fontSize: "15px" }} responsive>
                        <thead className="table-light" style={{verticalAlign: "middle", whiteSpace: "nowrap", cursor: "pointer", transition: "background-color 0.3s"}}>
                        <tr>
                            <th>ลำดับ</th>
                            {headerTable.map((header, index) => (
                            <th key={index} onMouseEnter={(e) => hoverEffect(e, true)} onMouseLeave={(e) => hoverEffect(e, false)} onClick={() => handleHeaderClick(header.field, index, !inversedSort)}>
                                {header.label}{sortIcon(index)}
                            </th>
                            ))}
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {dataTable.length === 0 ? (
                            <tr> <td colSpan="7" className="text-center fs-5"> ไม่มีข้อมูล </td> </tr>
                        ) : (
                            dataTable.map((user, index) => {
                            let cp = (currentPage - 1) * 10;
                            return (
                                <tr key={index} >
                                    <td>{index + cp + 1}</td>
                                    <td className="text-nowrap">{user.posi_no_id}</td>
                                    <td>{user.name_posi_no}</td>
                                    <td>
                                        <Badge color= {user.status == 1 ? 'success' : 'danger'} className="p-2 bg-opacity-10" >
                                            <span className={`text-${user.status == 1 ? 'success' : 'danger'} fs-6`}> {user.status == 1 ? 'ใช้งาน' : 'ไม่ใช้งาน'} </span>
                                        </Badge>
                                    </td>
                                    <td>{user.user_name}</td>
                                    <td>{user.user_start_posit ? ConvertDate(user.user_start_posit).toThaiDateFullDMY() : ""}</td>
                                    <td>
                                        <Button className='me-2 mt-1' color='warning' onClick={() => {setModal(true); setModalState("EDIT"); positionNoEditDataTable(user.position_no_id)} }><i className="fa-solid fa-pen-to-square"></i></Button>
                                        <Button className='mt-1' color='danger' onClick={() => {setConfirmModal(true); setDataInput({position_no_id: user.position_no_id}); setConfirmModalState("DELETE") }}><i className="fa-solid fa-trash"></i></Button>
                                    </td>
                                </tr>
                            );
                            })
                        )}
                        </tbody>
                    </Table>
                    <Modal isOpen={modal} centered toggle={toggles}>
                        <ModalHeader>
                            {modalState === "EDIT" && "แก้ไข"}รายละเอียดเลขที่ตำแหน่ง
                            <div className="position-absolute top-0 end-0">
                                <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{cursor: "pointer"}} onClick={toggles}></i>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup row>
                                <Label className="text-end" xxl={4} xs={4}> เลขที่ตำแหน่ง </Label>
                                <Col>
                                    <Input invalid={!dataInput.posi_no_id || checkNumber } value={isNaN(dataInput.posi_no_id) ? "" : dataInput.posi_no_id == 0 ? "" : dataInput.posi_no_id} type="text" name='posi_no_id' 
                                        onChange={ async (e) => { 
                                            handleInputChange(e, 'posi_no_id', true); 
                                            if (await checkValidateNumber(Number(e.target.value)) ) {
                                                setCheckNumber(false)
                                            } else {
                                                setCheckNumber(true)
                                            }
                                        }}
                                    ></Input>
                                    {(!dataInput.posi_no_id || checkNumber) && <FormFeedback>{!dataInput.posi_no_id ? "โปรดกรอกเลขที่ตำแหน่ง" : checkNumber ? "เลขที่ตำแหน่งนี้มีการลงทะเบียนไว้แล้ว" : "" }</FormFeedback>}
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xxl={4} xs={4}> ชื่อตำแหน่ง </Label>
                                <Col>
                                    <Input invalid={!dataInput.name_posi_no} value={dataInput.name_posi_no} type="text" name='name_posi_no' onChange={(e) => { handleInputChange(e, 'name_posi_no')}}></Input>
                                    {!dataInput.name_posi_no && <FormFeedback>โปรดกรอกชื่อตำแหน่ง</FormFeedback>}
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xxl={4} xs={4}> ชื่อผู้ดำรงตำแหน่ง </Label>
                                <Col>
                                    <Select className="basic-single" classNamePrefix="เลขที่ตำแหน่งหรือเจ้าหน้าที่" isSearchable={true} placeholder='เลขที่ตำแหน่งหรือเจ้าหน้าที่...' options={usersOnlyOptions} required={true}
                                        noOptionsMessage={()=>conditonMessage ? "กำลังดาวน์โหลดข้อมูล..." : "ไม่พบรายชื่อเจ้าหน้าที่ดังกล่าว"}
                                        defaultValue={usersOnlyOptions.find(option => option.value == dataInput?.user_id)?.value}
                                        onChange={e => { handleInputChange(e?.value, 'user_id', true, false, true) }} 
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xxl={4} xs={4}> ใช้งาน </Label>
                                <Col className='col align-self-center'>
                                    <Input type="checkbox" checked={Boolean(parseInt(dataInput.status))} name='status' onClick={(e) => {handleInputChange(!e.target.checked ? 1 : 0, 'status', true, true)} }></Input>
                                </Col>
                                {/* {modalState === "EDIT" && 
                                <>
                                    <Label className="text-end" xxl={4} xs={4}> สลับตำแหน่ง </Label>
                                    <Col className='col align-self-center'>
                                        <Input type="checkbox" onChange={(e) => setCheckSwitchUserPosiNo(e.target.checked)} name='switch_posino'></Input>
                                    </Col>
                                </>} */} 
                                {/* กรณีสลับ */}
                            </FormGroup>
                            {checkSwitchUserPosiNo && 
                            <FormGroup row>
                                <Label className="text-end" xxl={4} xs={4}> {usersOptions.find(option => option.value == dataInput?.user_id)?.value ? 'สลับตำแหน่ง' : 'ชื่อผู้ที่จะดำรงตำแหน่ง'} </Label>
                                <Col>
                                    <Select className="basic-single" classNamePrefix="เจ้าหน้าที่" isSearchable={true} placeholder='เจ้าหน้าที่...' options={usersOptions} required={true}
                                        noOptionsMessage={()=>conditonMessage ? "กำลังดาวน์โหลดข้อมูล..." : "ไม่พบรายชื่อเจ้าหน้าที่ดังกล่าว"}
                                        defaultInputValue= {usersOptions.find(option => option.value == dataInput?.user_id)?.label}
                                        onChange={e => {  
                                            if (usersOptions.find(option => option.value == dataInput?.user_id)?.value) {
                                                positionNoSwapData('user_id', e?.value) 
                                            } 
                                        }} 
                                    />
                                </Col>
                            </FormGroup>}
                        </ModalBody>
                        <ModalFooter>
                            <Button color={modalState === "ADD" ? "success" : modalState === "EDIT" ? "warning" : ""} onClick={() => {setConfirmModal(true); setConfirmModalState("RECORD");}} >
                                {modalState === "ADD" ? "บันทึก" : modalState === "EDIT" ? "บันทึกการแก้ไข" : "" }
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <ConfirmModal
                        modal = {confirmModal}
                        modalSize = "md"
                        modalHeaderContent ={confirmModalState === "DELETE" ? "คุณต้องการที่จะลบ ใช่หรือไม่?" : confirmModalState === "RECORD" ? "คุณต้องการที่จะบันทึก ใช่หรือไม่?" : ""}
                        onClickConfirmBtn={() => {
                        if (confirmModalState === "DELETE") {
                            positionNoDeleteDataTable();
                        } else if (confirmModalState === "RECORD") {
                            fetchToDB()
                        }
                        setConfirmModal(false)
                        }}
                        onClickCancelBtn={() => {
                        setConfirmModal(false)
                        }}
                    />
                    <Row
                        className="mx-2"
                        style={{
                        display: "flex",
                        alignItems: "center",
                        }}
                    >
                        <Col xxl={4}>
                            <h4 className="mb-0">
                                <Badge className="badge-soft-primary me-1 fs-5">
                                    ทั้งหมด {dataInfo?.totalRows} รายการ
                                </Badge>
                            </h4>
                        </Col>
                        <Col xxl={8} className="d-flex justify-content-center justify-content-sm-end">
                            <Pagination className="mt-3">
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink onClick={() => setCurrentPage(1)}> หน้าแรก </PaginationLink>
                                </PaginationItem>
                                <PaginationItem disabled={currentPage === 1}>
                                    <PaginationLink onClick={() => setCurrentPage(currentPage - 1)}> ย้อนกลับ </PaginationLink>
                                </PaginationItem>
                                <PaginationItem active> <PaginationLink>หน้า {currentPage} จาก {totalPages}</PaginationLink> </PaginationItem>
                                <PaginationItem disabled={currentPage === dataInfo.totalPage || totalPages === 0}>
                                    <PaginationLink onClick={() => setCurrentPage(dataInfo.currentPage + 1)}> ถัดไป </PaginationLink>
                                </PaginationItem>
                                <PaginationItem disabled={currentPage === totalPages || totalPages === 0}>
                                    <PaginationLink onClick={() => setCurrentPage(dataInfo.totalPage)}> หน้าสุดท้าย </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                        </Col>
                    </Row>
                    </Col>
                </Row>
                </FadeIn>
            )}
        </Fragment>
    )
}
export default UserpositionNoDatatable